// The single-metric API owns indicator explanations, including field aliases.
// The overview only joins that metadata onto its existing table contract.
export async function fetchOperationMetricNotes(http, category) {
  const { data } = await http.get('/api/v4/get_operation_data_button', {
    params: { category_2: category, report_type: 'quarterly' },
  });
  if (!data || data.code !== 200) throw new Error(data && data.msg);
  return (data.data && data.data.factor_maps) || {};
}

export function attachOperationMetricNotes(headers = [], notes = {}) {
  return headers.map((header) => {
    const note = notes[header.prop];
    if (typeof note !== 'string' || !note.trim()) return header;
    const existing = header.tooltip || '';
    if (existing === note || existing.startsWith(note + '<br><br>')) return header;
    return { ...header, tooltip: [note, existing].filter(Boolean).join('<br><br>') };
  });
}

// Numeric precision is part of the API metadata, not a metric-name special case.
export function formatOperationValue(value, numType) {
  if (value === '' || value === null || value === undefined) return '';
  const number = Number(value);
  if (!Number.isFinite(number)) return value;
  if (numType === 'pct') return (number * 100).toFixed(2) + '%';
  const format = /^num([0-9]|1[0-2])$/.exec(numType || '');
  return format ? number.toFixed(Number(format[1])) : value;
}
